export default class Merchant {
  constructor (merchant = {}) {
    this.id = merchant.id || null
    this.practiceId = merchant.practice_id || null
    this.status = merchant.status || null
    this.externalId = merchant.external_id || null
    this.publicKey = merchant.public_key || null
    this.createdAt = merchant.created_at || null
    this.updatedAt = merchant.updated_at || null
  }
}
